/**
 * Traduz o locale do vue-i18n (`pt_BR`, com underscore) pra tag BCP-47
 * (`pt-BR`, com hífen), que é o que `Intl.*` e `toLocaleString` entendem.
 *
 * Passar `pt_BR` cru pro `Intl` levanta `RangeError` — e como quase todo
 * chamador embrulha isso num try/catch com fallback, o erro não aparece: o
 * valor só sai formatado errado. Foi o que aconteceu no card do Kanban, que
 * exibia `BRL 0.00` em vez de `R$ 0,00` desde sempre, sem nada no console.
 *
 * Existiam três cópias desta linha (massiva, dataTables ×2) antes desta.
 */
export const intlLocale = locale => String(locale || 'pt-BR').replace('_', '-');

/**
 * Valor monetário no idioma da UI. Sem try/catch escondendo erro: o único
 * motivo real de falha era o locale inválido, que `intlLocale` já resolve —
 * moeda desconhecida é dado errado e deve estourar em desenvolvimento.
 */
export const formatCurrency = (amount, currency, locale) =>
  new Intl.NumberFormat(intlLocale(locale), {
    style: 'currency',
    currency: currency || 'BRL',
  }).format(Number(amount));
